<template>
  <px-cancelar-dialog
    :titulo="getTitulo"
    :descricao="getDescricao"
    @cancelar-dialog="onClickCancelar"
    :disabled="!isAberta"/>
</template>

<script>
import { SituacoesCotacao } from 'px-business-components';
import CotacaoProdutoService from '@/modules/cotacao/cotacao-produto-service';

export default {
  props: {
    cotacao: Object,
    cotacaoProduto: Object,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    isAberta() {
      return SituacoesCotacao.ABERTAS.includes(this.cotacaoProduto.situacao);
    },
    getTitulo() {
      return 'Cancelar produto';
    },
    getDescricao() {
      return `O produto "${this.descricaoItem()}" será cancelado e os fornecedores não poderão mais respondê-lo. Esta operação não pode ser desfeita.`;
    },
  },
  methods: {
    onClickCancelar(motivoRecusa) {
      this.loading = true;
      CotacaoProdutoService.cancelar(this.cotacao.id, this.cotacaoProduto.id, { motivoRecusa })
        .then(() => {
          this.$toast('Item cancelado com sucesso', { color: 'success' });
          this.$emit('update');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    descricaoItem() {
      const codigo = this.cotacaoProduto.produto.codigo ? `${this.cotacaoProduto.produto.codigo} - ` : '';
      if (this.cotacaoProduto.produto.isGenerico && this.cotacaoProduto.especificacaoProduto) {
        return codigo + this.cotacaoProduto.especificacaoProduto;
      }
      return codigo + this.cotacaoProduto.produto.descricao;
    },
  },
};
</script>
